import { ConfigBasedStructuralEntryDTO, ParkingSubscriptionDTO, ParkingTariffDTO, ZoneDTO, ZoneDeviceDTO } from "src/app/base/models/models.swagger.generated";

export interface DetailsInitInfo {
  id?: number;
  type: AdministrationItemType;
  parentId?: number; // mandatory for create
  parentType?: AdministrationItemType; // mandatory for create
  clientId?: number; // mandatory for create,
  uniqueIdent?: number; // to distinguish between items with same id and type (e.g. in tree view)
}

export interface ExtendedDetailsInitInfo extends DetailsInitInfo {
  treeNodeId?: string;
  itemData?: IItemData;
}

export enum AdministrationItemType {
  ZoneCollection = 0,
  ZoneDeviceCollection = 1, // needs to have a value smaller than Zone
  ZoneDevice = 2,
  Tariff = 3,
  Zone = 4,                 // needs to have higher value than tariff
  Subscription = 5,
  ConfigBasedStructuralElement = 6,
  ConfigBasedStructuralElementCollection = 7,
  SubscriptionCollection = 8,
  TariffCollection = 9,
}

export interface ParentInfo {
  item: ExtendedDetailsInitInfo;
  nodes: string[];
}

export interface ItemEventInfo {
  id: number;
  type: AdministrationItemType;
  parentId: number;
  data: ZoneDTO | ZoneDeviceDTO | ParkingTariffDTO | ParkingSubscriptionDTO | ConfigBasedStructuralEntryDTO;
};

export interface ICachedItem {
  id: number;
  type: AdministrationItemType;
  itemData: IItemData;
}

export interface ITreeNodeData {
  id: string;  // node id
  hasChildren: boolean;
  itemData: IItemData;
  expanded?: boolean;
}

export interface IItemData {
  type: AdministrationItemType;
  name: string;
  inactive: boolean;
  dto: any;
  isHighlighted?: boolean;
}

export interface IExtendedTreeNodeData extends ITreeNodeData {
  parentId: string;
  child: IExtendedTreeNodeData[];
}
